// ----------------------------------------------------------------------
// <copyright file='Izenda.BoardName.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// This component is only used for name of report/dashboard part on lists.
!(function() {


  var React = require('react');
  var ReactDOM = require('react-dom');
  var connect = require('share/enhancers/Izenda.Connect');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var Input = Validator()(require('share/components/controls/Izenda.Input'));
  var ACCESS_RIGHT = require('logic/data/Izenda.AuthorizationConstants').ACCESS_RIGHT;
  var uiState = require('logic/Izenda.UiState');
  const { isObject } = require('lodash/fp');
  module.exports = function(constants) {
    var SearchCriteria = constants.SEARCH_CRITERIA;

    var BoardName = React.createClass({
      propTypes: {
        store: React.PropTypes.object,
        dataDetail: React.PropTypes.object
      },

      getInitialState: function() {
        this.originalName = this.props.dataDetail.name;
        return { editMode: false };
      },

      /**
       * Handle enter
       * @param {Object} event
       */
      handleEnter: function(e) {
        if (e.key === 'Enter') {
          this.handleSaveName();
        }
      },

      handleSaveName: function(e) {
        var props = this.props;
        var dataDetail = props.dataDetail;
        dataDetail.setEditMode && dataDetail.setEditMode(true);

        // Stop event blur if current event is mouse down
        if (e && e.type === 'mousedown') {
          e.preventDefault();
          e.stopPropagation();
        }

        var valManager = this.props.validation;
        if (dataDetail.name === this.originalName) {
          dataDetail.setEditMode && dataDetail.setEditMode(false);
          this.setState({ editMode: false });
          return;
        }
        var loader = this.props.loader;

        valManager.validate('name').then(
          function(success) {
            if (success) {
              loader.startLoading();
              return props.store
                .rename(dataDetail)
                .then(
                  function(response) {
                    // If rename is successfully then API just returns boolean value, otherwise it returns an object.
                    if (!isObject(response)) {
                      dataDetail.setEditMode && dataDetail.setEditMode(false);
                      props.updateName && props.updateName(dataDetail.name);
                      this.originalName = props.dataDetail.name;
                      this.setState({ editMode: false });
                    } else {
                      ReactDOM.findDOMNode(this.refs.inputName.refs.editor).focus();
                      valManager.updateErrors(response.messages);
                    }
                  }.bind(this)
                )
                .finally(loader.endLoading.bind(loader));
            }
          }.bind(this)
        );
      },

      /**
       * Handle cancel button
       */
      handleCancelRename: function() {
        var props = this.props;
        var dataDetail = props.dataDetail;
        dataDetail.setEditMode && dataDetail.setEditMode(false);
        this.setState({ editMode: false });
        this.props.dataDetail.name = this.originalName;
      },

      /**
       * Rename
       * @param {Object} event
       */
      handleRename: function(e) {
        var props = this.props;
        var dataDetail = props.dataDetail;
        dataDetail.setEditMode && dataDetail.setEditMode(true);
        this.setState({ editMode: true });

        e.preventDefault();
        e.stopPropagation();
      },

      /**
       * Change name
       * @param {Object} input
       */
      onChangeName: function(input) {
        this.props.dataDetail.name = input.target.value;
        this.setState({ editMode: this.state.editMode });
      },

      /**
       * Render name component with edit mode
       * @return {Object} component
       */
      renderEditName: function() {
        var dataDetail = this.props.dataDetail;
        var localization = this.props.localization;

        return (
          <div className='title-edit form-group'>
            <div className='input-group'>
              <Input
                ref='inputName'
                value={dataDetail.name}
                onChange={this.onChangeName}
                onKeyPress={this.handleEnter}
                onBlur={this.handleSaveName}
                field='name'
                validations={constants.CONSTRAINTS.NAME}
                className='form-control'
                autoFocus
              />
              <span className='input-group-btn'>
                <button
                  className='btn btn-default'
                  onMouseDown={this.handleSaveName}
                  title={localization.getText('COMMON_TOOLTIP_UPDATE_CHANGE')}
                >
                  <span className='icon-ok success-color' />
                </button>
                <button
                  className='btn btn-default'
                  onMouseDown={this.handleCancelRename}
                  title={localization.getText('COMMON_TOOLTIP_CANCEL_CHANGE')}
                >
                  <span className='icon-cancel' />
                </button>
              </span>
            </div>
          </div>
        );
      },

      /**
       * Render name component with view mode
       * @return {Object} component
       */
      renderViewName: function() {
        var props = this.props;
        var dataDetail = props.dataDetail;
        var model = props.store.items || {};

        return (
          <div className='u_flexHorizontal'>
            <div className='u_textTruncate'>
              <a onClick={props.onClick}>
                <TextHighLight
                  highlight={model.searchText}
                  text={dataDetail.name}
                  className='text-bold'
                  notHighlight={
                    dataDetail.isNotHighLight && dataDetail.isNotHighLight(model.searchType, SearchCriteria[1].value)
                  }
                />
              </a>
            </div>
            <div className='u_fullInlineBlock'>
              {(((props.accessPriority === ACCESS_RIGHT.FullAccess ||
                props.accessPriority === ACCESS_RIGHT.QuickEdit ||
                props.accessPriority === ACCESS_RIGHT.SaveAs) &&
                props.hasRenamePermission &&
                !dataDetail.isGlobal) ||
                (dataDetail.isGlobal && uiState.currentUser.systemAdmin && !uiState.tenantId)) && (
                <a onClick={this.handleRename}>
                  <span className='icon-pencil-new' title={this.props.localization.getText('COMMON_TOOLTIP_RENAME')} />
                </a>
              )}
            </div>
          </div>
        );
      },

      /**
       * Render component
       * @return {Object} component
       */
      render: function() {
        return <div>{this.state.editMode ? this.renderEditName() : this.renderViewName()}</div>;
      }
    });

    return connect()(BoardName);
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.BoardName.jsx